import { PrinterMachineData } from '@/common/types/printerMachine.type';
import { printerMachinesStrategy } from '@/features/printerMachines/constants/printerMachinesStatus.constant';
import { ArrowBigRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

export class PrinterMachinesTransformer {
  static tableTransformer() {
    return (printerMachines: PrinterMachineData[]) => {
      return printerMachines.map((printerMachine) => ({
        display_name: printerMachine.display_name,
        status: printerMachinesStrategy[printerMachine.status as keyof typeof printerMachinesStrategy],
        part_number: printerMachine.part_number,
        printed_cards_count: printerMachine.printed_cards_count,
        actions: (
          <Link to={`/printer-machines/${printerMachine.id}`}>
            <ArrowBigRightIcon data-testid={`action_redirect_${printerMachine.display_name}`} strokeWidth={1} />
          </Link>
        ),
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (printerMachines: PrinterMachineData[]) => {
      return printerMachines.map((printerMachine) => ({
        route: `/printer-machines/${printerMachine.id}`,
        items: [
          ['Nome', printerMachine.display_name],
          ['Status', printerMachinesStrategy[printerMachine.status as keyof typeof printerMachinesStrategy]],
          ['Modelo', printerMachine.part_number],
        ]
      }));
    };
  }
}
